import { motion } from "framer-motion";
import { PaperPlaneRight, ShieldCheck } from "@phosphor-icons/react";
import { TELEGRAM_URL } from "@/App";

const SERVER_IMG =
  "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMHNlcnZlciUyMHJvb218ZW58MHx8fHwxNzgzOTU0OTIxfDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="border-t border-border bg-card/40"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36 grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <img
            src={SERVER_IMG}
            alt="Technical infrastructure"
            className="w-full h-[380px] sm:h-[520px] object-cover grayscale contrast-125 border border-border"
          />
          <div className="absolute -bottom-6 -right-2 sm:right-8 bg-background/80 backdrop-blur-xl border border-border p-6 max-w-xs">
            <ShieldCheck size={28} weight="duotone" className="text-accent mb-3" />
            <p className="font-code text-xs uppercase tracking-[0.15em] text-muted-foreground leading-relaxed">
              Years of hands-on experience across major platforms
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="font-code text-xs uppercase tracking-[0.2em] text-accent">
            [ 04 ] — About
          </span>
          <h2 className="font-display font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-5 mb-8">
            I&apos;m Craniel.
          </h2>
          <div className="space-y-6 font-body text-base sm:text-lg text-muted-foreground leading-relaxed max-w-lg">
            <p>
              I&apos;ve spent years handling account issues across every
              major social platform — working directly with support staff and
              employees at{" "}
              <span className="text-foreground font-medium">Meta</span>,{" "}
              <span className="text-foreground font-medium">Google</span>, and
              other platforms to resolve cases the right way.
            </p>
            <p>
              My clients include public figures, established creators, and
              businesses who need discreet, professional handling of sensitive
              account situations — from access recovery to platform-level
              disputes.
            </p>
            <p>
              Every case is honest, private, and handled personally until it&apos;s
              resolved.
            </p>
          </div>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-telegram-button"
            className="inline-flex items-center gap-3 mt-10 bg-accent text-accent-foreground px-8 py-4 font-code text-sm uppercase tracking-[0.15em] font-medium hover:bg-blue-500 transition-colors duration-200 group"
          >
            Reach out on Telegram
            <PaperPlaneRight
              size={18}
              weight="fill"
              className="group-hover:translate-x-1 transition-transform duration-200"
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
